var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors.length)?_c('div',{staticClass:"alert alert-danger"},[_c('ul',_vm._l((_vm.errors),function(error){return _c('li',{staticClass:"error-message"},[_vm._v("\n      "+_vm._s(_vm._f("capitalize")(error))+"\n    ")])}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57ce1074","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/ErrorsList.vue
// module id = wFzc
// module chunks = 0 1